var map = {
	"./choose.png": "36zO",
	"./un_choose.png": "Rnoc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9TYF";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*choose\.png$
// module id = 9TYF
// module chunks = 1